import React from 'react';
import { Listing } from 'src/interfaces/idashboard';

import { amenitiesObject } from 'src/utils/const';
import { COLOR_PRIMARY_2 } from 'src/utils/colors';
import { AmenitiesIcons } from 'src/utils/icons';
import { Typography, Grid, Stack, Box } from '@mui/material';
import TooltipNew from 'src/App/Dashboards/Market/Components/Tooltips/TooltipNew';

const ThreeColumnList = ({ currentListingAmeneties, marketAmenityDistro }) => {
  const amenityItemStyle = isEnabled =>
    isEnabled
      ? {
          color: COLOR_PRIMARY_2,
        }
      : {
          color: COLOR_PRIMARY_2 + '50',
          pointerEvent: 'none',
        };

  return (
    <Box>
      <Grid container spacing={4}>
        {Object.entries(amenitiesObject).map(([key, value], index) => {
          const CurrentAmenityListItem = (
            <Typography
              variant="body1"
              sx={{
                fontWeight: 500,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                gap: '10px',
                ...amenityItemStyle(currentListingAmeneties[key]),
              }}
            >
              {AmenitiesIcons[key]}
              {value}
            </Typography>
          );

          const percentageOfCurrentAmenityInMarket = marketAmenityDistro
            ? marketAmenityDistro[key] < 1
              ? 'less than 1'
              : marketAmenityDistro[key]
            : null;

          return (
            <Grid key={index} item container xs={6} sm={6} md={4} justifyContent={'flex-start'}>
              {percentageOfCurrentAmenityInMarket ? (
                <TooltipNew
                  title={''}
                  content={
                    <Typography
                      variant="body1"
                      sx={{ color: '#000', '& strong': { fontWeight: 'bold' } }}
                    >
                      <strong>{percentageOfCurrentAmenityInMarket}%</strong> listings in this market
                      have <strong>{value}</strong>
                    </Typography>
                  }
                  placement={'top'}
                >
                  {CurrentAmenityListItem}
                </TooltipNew>
              ) : (
                CurrentAmenityListItem
              )}
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

const Ameneties = ({
  data,
  isMobileScreen,
  marketAmenityDistro,
}: {
  data: any[] | Listing;
  isMobileScreen: boolean;
  marketAmenityDistro: { [key: string]: number };
}) => {
  const currentListingAmeneties = data['amenities'];

  return (
    <>
      <Typography color="textPrimary" variant="h6" sx={{ my: '20px' }}>
        Amenities
      </Typography>

      <Grid
        item
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        style={{ marginTop: isMobileScreen ? 0 : '10px' }}
        xs={12}
      >
        <Stack spacing={{ xs: 2 }} direction="row" sx={{ flexWrap: 'wrap' }}>
          <ThreeColumnList
            currentListingAmeneties={currentListingAmeneties}
            marketAmenityDistro={marketAmenityDistro}
          />
        </Stack>
      </Grid>
    </>
  );
};

export default Ameneties;
